module.exports = __webpack_public_path__ + "img/plane-booking-active.f3bc3485.svg";